/**
 * A11y 命名空间
 * 用于无障碍相关的 trigger 类型前缀
 */
export const a11yTriggerNamespace = 'fanfanlo/javajs/v1/project/components/triggers/a11y/'
